import cx from 'classnames';

import { MDText } from 'i18n-react';

import { Content } from 'LegacySBCRA/Content/Content';

import { usePageRefEvents } from '../../containers/app/common/Hooks/usePageRefEvents';

import LocalTexts from './PartnerLogosTexts.json';

import styles from './PartnerLogos.scss';

const LocalT = new MDText(LocalTexts);

const t = (key: string) => LocalT.translate(key) as string;

const TEXT = {
  title: t('partner.title'),
};

type Props = {
  children: React.ReactNode;
  className?: string;
  onRefTrigger: () => void;
}

export const PartnerLogos: React.FC<Props> = ({ children, className, onRefTrigger }: Props) => {
  const { setRef } = usePageRefEvents({ onRefTrigger });

  return (
    <Content
      className={styles.component}
      wrapper={{ className: cx(styles.componentWrapper, className) }}
    >
      <h3 className={cx(styles.belowBreakpointContentTitle)}>{TEXT.title}</h3>
      <div
        ref={(ref) => setRef(ref)}
        className={styles.logos}
        data-testid="partnerLogos"
      >
        <h3 className={cx(styles.aboveBreakpointContentTitle)}>{TEXT.title}</h3>
        {children}
      </div>
    </Content>
  );
};
